export default "__VITE_PUBLIC_ASSET__26487391__"